module.exports = __webpack_public_path__ + "img/study-mode-faq-2.65178b30.png";